"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphicsOverlay = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var pusher_js_1 = __importDefault(require("pusher-js"));
var ra_fetch_1 = require("ra-fetch");
var pusher = null;
var GraphicsOverlay = function (props) {
    var channelId = props.channelId, initialState = __rest(props, ["channelId"]);
    var _a = react_1.useState(initialState), _b = _a[0], matchTime = _b.matchTime, matchTimerInterval = _b.matchTimerInterval, playing = _b.playing, scores = _b.scores, teams = _b.teams, setState = _a[1];
    function abbreviateTeamName(name) {
        if (name === void 0) { name = 'n/a'; }
        return name.replace(/\s/g, '').slice(0, 3).toUpperCase();
    }
    function getVideo() {
        ra_fetch_1.Fetcher.api('backend')
            .index('public.videos', {
            external_id: channelId,
            details: true,
            resource: 'VideoFull'
        })
            .then(function (videos) {
            if (videos.errors.length > 0) {
                throw new Error(JSON.stringify(videos.errors));
            }
            var video = videos.data[0];
            setState(function (state) {
                var _a, _b, _c, _d;
                return (__assign(__assign({}, state), { teams: [
                        __assign(__assign({}, video.team), { nameAbbreviated: abbreviateTeamName((_b = (_a = video === null || video === void 0 ? void 0 : video.team) === null || _a === void 0 ? void 0 : _a.club) === null || _b === void 0 ? void 0 : _b.label), colour: '#F7323F' }),
                        __assign(__assign({}, video.opponent), { nameAbbreviated: abbreviateTeamName((_d = (_c = video === null || video === void 0 ? void 0 : video.opponent) === null || _c === void 0 ? void 0 : _c.club) === null || _d === void 0 ? void 0 : _d.label), colour: '#FF8900' })
                    ] }));
            });
        })
            .catch(function (err) {
            console.error(err);
        });
    }
    function getScores() {
        ra_fetch_1.Fetcher.api('producer')
            .show('scores', {
            jw_id: channelId,
        })
            .then(function (scores) {
            setState(function (state) { return (__assign(__assign({}, state), { scores: scores.data })); });
            if (scores.errors) {
                throw new Error(JSON.stringify(scores.errors));
            }
        })
            .catch(function (err) { return console.error(err); });
    }
    function getMatchTime() {
        ra_fetch_1.Fetcher.api('producer')
            .show('clock', {
            jw_id: channelId,
        })
            .then(function (clock) {
            var _a, _b;
            setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { matchTime: ((_a = clock === null || clock === void 0 ? void 0 : clock.data) === null || _a === void 0 ? void 0 : _a.time) || 0 }));
            });
            if ((_a = clock === null || clock === void 0 ? void 0 : clock.data) === null || _a === void 0 ? void 0 : _a.startClock) {
                startClock(matchTime);
            }
            if ((_b = clock === null || clock === void 0 ? void 0 : clock.data) === null || _b === void 0 ? void 0 : _b.stopClock) {
                stopClock(matchTime);
            }
            if (clock.errors) {
                throw new Error(JSON.stringify(scores.errors));
            }
        })
            .catch(function (err) { return console.error(err); });
    }
    function startClock(time) {
        setState(function (state) { return (__assign(__assign({}, state), ('undefined' === typeof state.matchTimerInterval ? {
            matchTime: time || state.matchTime,
            matchTimerInterval: setInterval(function () {
                setState(function (state) { return (__assign(__assign({}, state), { matchTime: state.matchTime + 1 })); });
            }, 1000),
            playing: true
        } : {}))); });
    }
    function stopClock(time) {
        setState(function (state) {
            clearInterval(state.matchTimerInterval);
            return __assign(__assign({}, state), { matchTime: time || state.matchTime, matchTimerInterval: undefined, playing: false });
        });
    }
    function matchTimeFormatted() {
        var seconds = matchTime % 60;
        var minutes = (matchTime - (matchTime % 60)) / 60;
        return (minutes > 9 ? minutes : '0' + minutes) + ":" + (seconds > 9 ? seconds : '0' + seconds);
    }
    function getScoreByTeam(team) {
        if (!team.hasOwnProperty('id')) {
            return 0;
        }
        var teamScore = scores
            .filter(function (score) { return parseInt(score.team_id) === parseInt(team.id); })[0];
        return (teamScore === null || teamScore === void 0 ? void 0 : teamScore.score) || 0;
    }
    react_1.useEffect(function () {
        pusher = new pusher_js_1.default(process.env.NEXT_PUBLIC_STORYBOOK_PUSHER_APP_KEY, {
            cluster: process.env.NEXT_PUBLIC_STORYBOOK_PUSHER_APP_CLUSTER
        });
        var channel = pusher.subscribe(channelId);
        channel.bind('matchUpdated', function (_a) {
            var message = _a.message;
            if (message.startClock) {
                startClock(message.time);
            }
            else if (message.stopClock) {
                stopClock(message.time);
            }
        });
        channel.bind('scoreUpdated', function (_a) {
            var message = _a.message;
            setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { scores: __spreadArray(__spreadArray([], (_a = state === null || state === void 0 ? void 0 : state.scores) === null || _a === void 0 ? void 0 : _a.filter(function (score) {
                        return parseInt(score === null || score === void 0 ? void 0 : score.team_id) !== parseInt(message.team_id);
                    })), [message]) }));
            });
        });
        // Prep data
        getVideo();
        getScores();
        getMatchTime();
        // Auto start clock and resume from previous time
        if (!playing && matchTime !== 0) {
            startClock();
        }
        return function cleanUp() {
            // Unbind all handlers
            channel.unbind();
            // Disconnect from Pusher
            pusher.disconnect();
            // Remove interval
            clearInterval(matchTimerInterval);
        };
    }, []);
    return (react_1.default.createElement("svg", { className: 'storybook-graphicsoverlay-overlay', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1920 1080" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-bg-white', x: "206", y: "120", width: "100", height: "40" }),
            react_1.default.createElement("text", { className: 'storybook-graphicsoverlay-text', transform: "translate(222.82 150.44)" }, matchTimeFormatted()),
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-shadow', x: "206", y: "120", width: "100", height: "4" })),
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-bg-dark', x: "106", y: "80", width: "100", height: "40" }),
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-bg-white', x: "100", y: "80", width: "6", height: "40" }),
            react_1.default.createElement("text", { className: 'storybook-graphicsoverlay-text storybook-graphicsoverlay-text-white', transform: "translate(120.66 110.44)" }, teams[0].nameAbbreviated),
            react_1.default.createElement("path", { className: 'storybook-graphicsoverlay-bg-white', d: "M1799.52,99.38c-2.72-1.77-6.65-3.09-11.71-3.92a165.68,165.68,0,0,0-41.11,0c-5,.83-9,2.15-11.71,3.92a13.11,13.11,0,0,0-5.2,6.3c-1.51,3.56-2.27,8.48-2.27,14.63s.76,11.08,2.27,14.63a13.14,13.14,0,0,0,5.2,6.31c2.72,1.76,6.66,3.08,11.71,3.91a165.68,165.68,0,0,0,41.11,0,37.73,37.73,0,0,0,9.25-2.59l-9.34-7-1.45.26a157.78,157.78,0,0,1-38,0c-4.94-.82-7.21-1.94-8.12-2.53a3.83,3.83,0,0,1-1.66-2.07c-.56-1.35-1.52-4.56-1.52-11s1-9.61,1.52-11a3.83,3.83,0,0,1,1.66-2.07c.91-.59,3.18-1.71,8.12-2.53a157.78,157.78,0,0,1,38,0c4.94.82,7.21,1.94,8.12,2.53a3.83,3.83,0,0,1,1.66,2.07,21.41,21.41,0,0,1,1.32,6.25H1778V125h28.8c.11-1.48.16-3,.16-4.71,0-6.15-.76-11.07-2.27-14.63A13.11,13.11,0,0,0,1799.52,99.38Z" })),
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-bg-white', x: "406", y: "80", width: "6", height: "40" }),
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-bg-dark', x: "306", y: "80", width: "100", height: "40" }),
            react_1.default.createElement("text", { className: 'storybook-graphicsoverlay-text storybook-graphicsoverlay-text-white', transform: "translate(325.71 110.44)" }, teams[1].nameAbbreviated),
            react_1.default.createElement("path", { className: 'storybook-graphicsoverlay-bg-white', d: "M1807.07,87.74c-4.39-2.84-10-4.8-17-6a177.94,177.94,0,0,0-45.65,0c-7,1.16-12.6,3.12-17,6-9.41,6.11-13.79,16.45-13.79,32.57s4.38,26.47,13.79,32.57c4.39,2.85,10,4.8,17,6a177.94,177.94,0,0,0,45.65,0c7-1.16,12.6-3.11,17-6,9.41-6.1,13.79-16.45,13.79-32.57S1816.48,93.85,1807.07,87.74Zm1.75,48.94a17.61,17.61,0,0,1-6.88,8.29c-3.28,2.13-7.66,3.63-13.4,4.58a169.72,169.72,0,0,1-42.57,0c-5.74-1-10.12-2.45-13.4-4.58a17.53,17.53,0,0,1-6.87-8.29c-1.74-4.11-2.63-9.62-2.63-16.37s.89-12.26,2.63-16.36a17.51,17.51,0,0,1,6.87-8.3c3.28-2.13,7.66-3.63,13.4-4.58a169.72,169.72,0,0,1,42.57,0c5.74,1,10.12,2.45,13.4,4.58a17.59,17.59,0,0,1,6.88,8.3c1.74,4.1,2.62,9.61,2.62,16.36S1810.56,132.57,1808.82,136.68Z" })),
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-shadow', x: "202", y: "80", width: "108", height: "40" }),
            react_1.default.createElement("rect", { className: 'storybook-graphicsoverlay-bg-secondary', x: "206", y: "80", width: "100", height: "40" }),
            react_1.default.createElement("text", { className: 'storybook-graphicsoverlay-text', transform: "translate(230.43 110.44)" }, getScoreByTeam(teams[0]) + " - " + getScoreByTeam(teams[1])))));
};
exports.GraphicsOverlay = GraphicsOverlay;
exports.GraphicsOverlay.propTypes = {
    channelId: prop_types_1.default.string,
    matchTime: prop_types_1.default.number,
    playing: prop_types_1.default.bool,
    scores: prop_types_1.default.array,
    teams: prop_types_1.default.array
};
exports.GraphicsOverlay.defaultProps = {
    channelId: 'default',
    matchTime: 0,
    playing: false,
    scores: [{
            score: 0
        }, {
            score: 0
        }],
    teams: [{
            nameAbbreviated: ''
        }, {
            nameAbbreviated: ''
        }]
};
